import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
  ViewEncapsulation,
} from '@angular/core';
import { JsonViewItemComponent } from '../json-view-item/json-view-item.component';

@Component({
  selector: 'ct-extraction-nxt-json-view',
  template: `
    <div class="nxt-json-view">
      <ct-extraction-nxt-json-view-item
        [data]="data()"
        [level]="0"
        [expansionState]="expansionState()"
        class="json-view" />
    </div>
  `,
  encapsulation: ViewEncapsulation.Emulated,
  imports: [JsonViewItemComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JsonViewComponent {
  readonly data = input.required<unknown>();

  protected readonly expansionState = signal<ExpansionState>({ type: 'expandedTo', level: 0 });

  expandTo(level: number) {
    this.expansionState.set({ type: 'expandedTo', level });
  }

  collapseTo(level: number) {
    this.expansionState.set({ type: 'collapsedTo', level });
  }
}

export interface ExpansionState {
  type: 'expandedTo' | 'collapsedTo';
  level: number;
}
